import FontFaceObserver from "fontfaceobserver";

const materialIconsObserver = new FontFaceObserver("Material Icons");

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Material Icons load initializer.
 * It fixes initial icons display because either in swap or block mode
 * they are causing spacing issues within html elements,
 * so we initialize them here, manually, to prevent this.
 */
const initMaterialIcons = () => {
  materialIconsObserver
    .load("font_download")
    .then(() => document.body.classList.add("site--ui-icons-loaded"));
};

export default initMaterialIcons;
